// extracted by mini-css-extract-plugin
export default {"majorContainer":"modal_majorContainer__skb7Y"};